import React, { } from "react";
import SubContractorsTable from "./SubContractorsTable";
import { useQuery } from "@apollo/client/react";
import { GetCompanyResourcesDocument, CompanyResourceResourceTypeEnum, CompanyResource } from "@/graphql/generated/graphql";

const SubContractorManagement: React.FC = () => {
  const { data, loading } = useQuery(GetCompanyResourcesDocument, {
    variables: {
      resourceType: CompanyResourceResourceTypeEnum.SubContractor,
    }
  });

  return (
    <SubContractorsTable
      loading={loading}
      data={data?.getCompanyResources as CompanyResource[] || []}
    />
  );
};

export default SubContractorManagement;
